import { createFileRoute } from "@tanstack/react-router";
import { PerformanceProfiler } from "@/pages/3d/debug/PerformanceProfiler";

export const Route = createFileRoute("/demo/3d/debug/performance-profiler")({
  component: PerformanceProfiler,
});
